var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticStyle:{"height":"440px"},attrs:{"id":_vm.id,"name":_vm.id,"rows":"10","cols":"30","aria-label":"editor"}},[_vm._v("      "+_vm._s(_vm.texto)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared-components/editor/Editor.vue?vue&type=template&id=04e871d2&lang=html&
// module id = 1510
// module chunks = 28